import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import format from "date-fns/format";
import I18n from "i18next";

const sx = {
  date: {
    width: "165px",
    display: "inline-block"
  },
  divider: {
    margin: "18px 0px",
    backgroundColor: "blue.c20"
  }
};

const ReportHistory = ({ HistoryData }) => {
  return HistoryData?.details.map((val) => {
    const content = (
      <Box key={val.partnerReportAuditId}>
        <Box sx={sx.date} component="span">
          <Typography variant="body2B" color="blue.c100">{`${format(
            new Date(val.createdOn),
            "LL/dd/yyyy"
          )}`}</Typography>{" "}
          <Typography variant="body2" component="span" color="blue.c100">{`${format(
            new Date(val.createdOn),
            "hh:mma"
          )}`}</Typography>{" "}
        </Box>
        <Typography variant="body2" component="span">{`${I18n.t("common.file")} ${val.action}`}</Typography>
        <Divider sx={sx.divider} />
      </Box>
    );
    return content;
  });
};

export default ReportHistory;
